import { ItemList } from "./ItemList";
import { ScrollItemEvent } from "./ScrollItemEvent";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;

/**
 *
 * Component:    ItemScrollList
 *
 * This component is based on a fixed number of visible "container"-items (ScrollItem) that change their content (ScrollItemVO) when scrolling.
 *
 * @param disp
 *         The disp-parameter should be a MovieClip-Container "mc_itemContainer" with the following childs:
 *         mc_itemContainer.item0
 *         mc_itemContainer.item1
 *         ..
 *         mc_itemContainer.item[itemsVisibleAtOnce]
 *
 *         mc_itemContainer.btn_up
 *         mc_itemContainer.btn_down
 *
 *      mc_itemContainer.txt_index
 *
 * Dispatches ScrollItemEvent.CLICK
 *
 * @param scrollLayer is a MovieClip on which the MouseWheel can be used
 *
 * @function hideButtons switches between hiding and disabling(desaturate) the scrollbuttons
 *
 */

export class ItemScrollList extends ItemList {

    private _scrollLayer: MovieClip;
    private _hideButtons: boolean = true;
    private _locked: boolean = false;

    protected _scrollStep: number = 1;

    constructor(disp: MovieClip, scrollLayer: MovieClip = null) {

        super(disp);

        this._scrollLayer = scrollLayer;

        if (this._scrollLayer) {
            this._scrollLayer.addEventListener("wheel", this.bindFunction(this.onMouseWheel));
        }
        else {
            this._componentDisp.addEventListener("wheel", this.bindFunction(this.onMouseWheel));
        }

    }

		/*override*/ public initList(startItem: number = 0, allowEmptyPlacesAtTheEnd: boolean = false): void {
        if (allowEmptyPlacesAtTheEnd) {
            this.updateItemList(Math.max(startItem, 0));
        }
        else {
            this.updateItemList(Math.min(startItem, (Math.max(this._itemCount - this._itemsVisibleAtOnce, 0))));
        }
        this.updateActiveStates();
    }

		/*override*/ protected updateItemList(startItem: number = 0): void {
        super.updateItemList(startItem);

        if (this._hideButtons) {
            this.btn_up.visible = this._currentStartIndex > 0;
            this.btn_down.visible = this._currentStartIndex < this._itemCount - this._itemsVisibleAtOnce;
        }
        else {
            // Check if ExternalDialog
            if ((<any>this.btn_up).basicButton) {
                (<any>this.btn_up).basicButton.enableButton = this._currentStartIndex > 0;
                (<any>this.btn_down).basicButton.enableButton = this._currentStartIndex < this._itemCount - this._itemsVisibleAtOnce;
            }
            else {
                (<any>this.btn_up).enableButton = this._currentStartIndex > 0;
                (<any>this.btn_down).enableButton = this._currentStartIndex < this._itemCount - this._itemsVisibleAtOnce;
            }
            this.btn_up.visible = true;
            this.btn_down.visible = true;
        }

        if ((<any>this._componentDisp).txt_index) {
            let minCurrentPage: number = this._itemCount > 0 ? 1 : 0;
            (<any>this._componentDisp).txt_index.text = (Math.max(minCurrentPage, Math.ceil(this._currentStartIndex / this._scrollStep))) + " / " + Math.ceil(this._itemCount / this._scrollStep);
        }
    }

    protected onMouseWheel(event: MouseEvent): void {
        if (event.delta < 0) // Mouse UP
        {
            this.naviUp();
        }
        else if (event.delta > 0) // Mouse Down
        {
            this.naviDown();
        }
    }

		/*override*/ protected naviUp(): void {
        if (this._locked) {
            return;
        }

        if (this._currentStartIndex > 0) {
            this.updateItemList(Math.max(0, this._currentStartIndex - this._scrollStep));
        }
        this.updateActiveStates();
        this.dispatchEvent(new ScrollItemEvent(ScrollItemEvent.ON_SCROLL, null, null));
    }

		/*override*/ protected naviDown(): void {
        if (this._locked) {
            return;
        }

        if (this._currentStartIndex < (this._itemCount - this._itemsVisibleAtOnce)) {
            this.updateItemList(this._currentStartIndex + this._scrollStep);
        }
        this.updateActiveStates();
        this.dispatchEvent(new ScrollItemEvent(ScrollItemEvent.ON_SCROLL, null, null));
    }

    public set scrollStep(value: number) {
        this._scrollStep = value;
    }

    public get hideButtons(): boolean {
        return this._hideButtons;
    }

    public set hideButtons(value: boolean) {
        this._hideButtons = value;
    }

    protected get btn_up(): MovieClip {
        return (<any>this._componentDisp).btn_up;
    }

    protected get btn_down(): MovieClip {
        return (<any>this._componentDisp).btn_down;
    }

		/*override*/ public remove(): void {
        if (this._scrollLayer) {
            this._scrollLayer.removeEventListener("wheel", this.bindFunction(this.onMouseWheel));
        }
        else {
            this._componentDisp.removeEventListener("wheel", this.bindFunction(this.onMouseWheel));
        }

        super.remove();
    }

    public lockList(): void {
        this._locked = true;
    }

    public unlockList(): void {
        this._locked = false;
    }

    public get locked(): boolean {
        return this._locked;
    }
}

